import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { MsgUnsubscribeService } from '../msg-unsubscribe.service';
import { MsgUnsubscribe } from '../msg-unsubscribe';

@Component({
    selector: 'app-msg-unsubscribe',
    templateUrl: './msg-unsubscribe.component.html',
    styleUrls: ['./msg-unsubscribe.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class MsgUnsubscribeComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private msgUnsubscribeService: MsgUnsubscribeService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.msgUnsubscribe = data.msgUnsubscribe,
			this.statuses = msgUnsubscribeService.statuses;
	}

	@Input() msgUnsubscribe: MsgUnsubscribe;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	msgUnsubscribeId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'msgUnsubscribeId': [],
		'emailAddress': [{ type: 'required', message: 'Eamil address is required.' }, { type: 'email', message: 'Enter valid eamil address.' }],
		'unsubscribeEmailId': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole msgUnsubscribe object
		if (this.msgUnsubscribe) {
			this.msgUnsubscribeId = this.msgUnsubscribe.msgUnsubscribeId;
			this.fixDates();
			this.form1.patchValue(this.msgUnsubscribe);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.msgUnsubscribeId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.msgUnsubscribeService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.msgUnsubscribe = res.data.msgUnsubscribe;
						this.doAdd.emit(this.msgUnsubscribe);
					},
					(err: any) => {
						console.log('msgUnsubscribe-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('msgUnsubscribe: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.msgUnsubscribeService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.msgUnsubscribe = res.data.msgUnsubscribe;
						this.doUpdate.emit(this.msgUnsubscribe);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.msgUnsubscribeService.delete(this.msgUnsubscribe.msgUnsubscribeId)
				.subscribe(
					(res: any) => {
						console.log('msgUnsubscribe-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.msgUnsubscribe);
					},
					(err: any) => {
						console.log('msgUnsubscribe-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			msgUnsubscribeId: [this.msgUnsubscribeId],
			emailAddress: ['', [Validators.required, Validators.email]],
			unsubscribeEmailId: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.msgUnsubscribe.msgUnsubscribeDate = moment(this.msgUnsubscribe.msgUnsubscribeDate).toDate();
	}
}
